import React from 'react';
import { translate } from 'react-i18next';
import {Card, Form, Button, Label, Icon, Header} from 'semantic-ui-react'

import {getCategoryImageUrl, getNotification, getNotificationFrequency, formatTime} from 'modules/categories/tools.js';
import Utils from 'utils/Utils.js';
import SurveyButtons from './SurveyButtons.js';
import {colors, fontSizes, shadow, spacings, layout} from 'style';
import styleDef from './style.js';

var style = {
    ...styleDef,
    content: {
        ...styleDef.content,
        maxWidth: layout.screenWidth,
    },
    heading:{
        color: colors.themeBlue,
        fontSize: fontSizes.h2,
        lineHeight: '1.5',
    },
    cardGroup: {
        textAlign: 'left',
        justifyContent: 'center',
    },
    card: {
        overflow:'hidden',
        color: '#fff',
        backgroundColor: colors.themeBlue,
    },
    header: {
        fontSize: '1em',
        color:'#fff', 
    },
    meta: {
        color:'#fff', 
    },
    iconHeader: {
        height:'42px', 
        padding:'10px 0px 0px 10px', 
        width:'100%',
        color: '#fff',
        backgroundColor: colors.themeTeal,
    },
    imageBanner: {
        position: 'relative',
        height:'158px', 
        width:'100%',
        backgroundSize:'100%',
        backgroundPositionY: 'center',
    },
    reloadIcon: {
        position: 'absolute',
        bottom: '-15px',
        right: '5px',
        width: '42px',
        height: '42px',
        paddingTop: '6px',
        boxShadow: shadow,
        borderWidth: '3px',
        borderStyle: 'solid',
        color: colors.themeTeal,
        borderColor: colors.themeTeal,
        borderRadius: '50%',
        backgroundColor: '#fff',
        cursor: 'pointer',
    },
    name: {
        color: colors.themeBlue,
    },
    goals: {
        color: colors.themeTeal,
    },
}

const SurveyPageText = ({t,
                         userProfile,
                         topPicks,
                         categories,
                         surveyPage, 
                         inlineButtons, 
                         onSubmit, 
                         onSkip, 
                         onCycleCategory,
                         pageNum, 
                         numPages}) => (
    <div style={style.container}>
    <div style={style.blank}>
        <div style={style.content}>
            <form onSubmit={onSubmit}>

                <div style={style.heading}>{surveyPage.title}</div>

                <div style={style.description}>
                    {surveyPage.description}
                    {/*
                    Based on your objectives and<br/> 
                    persona, <span style={style.name}>{userProfile.firstName}</span>, here are <span style={style.goals}>{topPicks.length} Goals</span><br/>
                    we have identified for you:
                    */}
                </div>
                <br/>
                <br/>

                <Card.Group style={style.cardGroup}>
                {topPicks.map(tp=>categories[tp]).map((category, i)=>(
                            <Card key={category.id} style={style.card}>
                                <div style={style.iconHeader}>
                                    <Icon size='large' className={category.icon}></Icon> 
                                    {category.title}
                                </div>
                                <div style={{...style.imageBanner, backgroundImage:Utils.url(getCategoryImageUrl(category))}}>
                                    {Boolean(topPicks.length < categories.length) &&
                                        <Icon style={style.reloadIcon} size='large' name='refresh' onClick={()=>onCycleCategory(category, i)} />
                                    }
                                </div>
                                <Card.Content>
                                    <Card.Header style={style.header}>
                                        {category.levelReq > 1 &&
                                            <Card.Meta style={style.meta}>Level {category.levelReq}</Card.Meta>
                                        }
                                    </Card.Header>
                                    {(((category.notifications && category.notifications[0]) ? category.notifications[0].time : category.defaultTime)>=0) &&
                                        <Card.Meta style={style.meta}>{t('categories:::Scheduled_Time_{{t}}', {t: formatTime((category.notifications && category.notifications[0]) ? category.notifications[0].time : category.defaultTime)})}</Card.Meta>
                                    }
                                </Card.Content>
                            </Card>
                        )
                    )    
                }
                </Card.Group>
                <SurveyButtons canSkip={surveyPage.canSkip} onSkip={onSkip} onSubmit={onSubmit} inlineButtons={inlineButtons} />

                <div style={style.spacer} />       
            </form>

        </div>
    </div>
    </div>
);

export default translate(['surveys', 'categories'])(SurveyPageText);



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyPageRecommendations.js